import { useMutation, useQueryClient } from "react-query";

export const useEditMutation = (apiRoot) => {
  const editFunc = useMutation((toMutate) => apiRoot.update(toMutate));
  return editFunc.mutate;
};
export const useCreateMutation = (apiRoot) => {
  const createFunc = useMutation((toCreate) => apiRoot.create(toCreate));
  return createFunc.mutate;
};
export const useCreateMultipleMutation = (apiRoot) => {
  const createFunc = useMutation((itemsToCreate) =>
    itemsToCreate.forEach((item) => apiRoot.create(item))
  );
  return createFunc.mutate;
};
export const useDeleteMutation = (apiRoot, idKey = "id") => {
  const deleteFunc = useMutation((toMutate) => apiRoot.delete(toMutate[idKey]));
  return deleteFunc.mutate;
};
export const useDeleteMultipleMutation = (apiRoot, idKey = "id") => {
  const deleteFunc = useMutation((itemsToMutate) =>
    itemsToMutate.forEach((item) => apiRoot.delete(item[idKey]))
  );
  return deleteFunc.mutate;
};

export const useMutationHandler = (
  queryKeys,
  mutationFunc,
  successCallback = (data) => {},
  errorCallback = (err) => {
    console.warn(err);
  }
) => {
  const queryClient = useQueryClient();

  return (itemToMutate) =>
    mutationFunc(itemToMutate, {
      onSuccess: (data, mutationVariables) => {
        queryKeys.forEach((key) => queryClient.invalidateQueries(key));

        successCallback(data);
      },
      onError: (error, mutationVariables) => {
        errorCallback(error);
      },
    });
};

export const usePrefetchQuery = async (queryKey, fetchFunc) => {
  const queryClient = useQueryClient();
  // The results of this query will be cached like a normal query
  await queryClient.prefetchQuery(queryKey, fetchFunc);
};
